import { Numeric0BoxOutlineIcon } from './Numeric0BoxOutlineIcon';

/**
 * author: Google
 * id 1EB53615-9A62-4377-A2D0-246C8F42CAF8
 * name numeric-0-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-0-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number0BoxOutlineIcon = Numeric0BoxOutlineIcon;
export default Number0BoxOutlineIcon